<template>
    <div class="kits-page">
        <app-sub-title text="Kits" />
        <div class="kits-page-buttons">
            <button class="btn btn-primary" v-if="userCan('create-kits')" @click="openForm">
                <i class="fa fa-plus"></i> Crear Kit
            </button>
        </div>
        <app-kits-list
            :kits="kits"
            :on-edit="onEdit"
            :on-delete="onDelete"
        />

        <!-- PopUps -->
        <app-pop-up
            id="kit-form"
            :title="!kit ? 'Crear Kit' : 'Editar Kit'"
            :on-close="() => $bus.$emit('kit-form.clear')"
            size="extra-large"
        >
            <div slot="body">
                <app-kit-form
                    :selected-kit="kit"
                    :available-items="availableItems"
                    :on-save="onSave"
                    id="kit-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-primary"
                    :disabled="saving"
                    @click="saveKit"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            id="kit-delete-confirm"
            title="Confirmar Eliminación"
            :on-close="onDeleteModalClose"
        >
            <div slot="body">
                <p class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    Esta acción no se puede deshacer.
                </p>
                <p>
                    ¿Está seguro de eliminar el kit
                    <strong>"{{ kitToDelete ? kitToDelete.name : '' }}"</strong>?
                </p>
            </div>
            <div slot="buttons">
                <button class="btn btn-danger" @click="confirmDelete" :disabled="deleting">
                    <i class="fa fa-trash"></i> Eliminar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import kitsRepository from '../../../repositories/kits.repository';
import SubTitle from '../../UI/Layout/SubTitle.vue';
import KitsList from './KitsList/KitsList.vue';
import KitForm from './KitForm/KitForm.vue';
import { mixin } from '../../../mixin';

export default {
    mixins: [mixin],
    components: {
        appSubTitle: SubTitle,
        appKitsList: KitsList,
        appKitForm: KitForm
    },
    data() {
        return {
            kits: [],
            kit: null,
            kitToDelete: null,
            deleting: false,
            availableItems: [],
            saving: false
        };
    },
    methods: {
        loadKits() {
            const pr = { ...kitsRepository };
            pr.getKits()
                .then(response => {
                    this.kits = response || [];
                })
                .catch(error => {
                    console.error('Error al cargar kits:', error);
                    toastr.error('Ocurrió un error al cargar los kits');
                });
        },
        loadAvailableItems() {
            const pr = { ...kitsRepository };
            pr.getAvailableItems()
                .then(response => {
                    this.availableItems = response || [];
                })
                .catch(error => {
                    console.error('Error al cargar items:', error);
                    toastr.error('Ocurrió un error al cargar los items disponibles');
                });
        },
        onEdit(kit) {
            this.kit = kit;
            this.openForm();
        },
        onDelete(kit) {
            this.kitToDelete = kit;
            this.openDeleteModal();
        },
        openDeleteModal() {
            this.$bus.$emit('kit-delete-confirm.open');
        },
        onDeleteModalClose() {
            this.kitToDelete = null;
            this.deleting = false;
        },
        closeDeleteModal() {
            this.$bus.$emit('kit-delete-confirm.close');
        },
        confirmDelete() {
            if (!this.kitToDelete) {
                return;
            }

            this.deleting = true;
            const pr = { ...kitsRepository };
            pr.deleteKit(this.kitToDelete.id)
                .then(response => {
                    if (!response || !response.status) {
                        toastr.error(response?.msg || 'Error al eliminar el kit');
                        this.deleting = false;
                        return;
                    }
                    
                    this.closeDeleteModal();
                    this.loadKits();
                    toastr.success(response.msg || 'El kit ha sido eliminado');
                    this.deleting = false;
                })
                .catch(error => {
                    console.log('error al eliminar el kit', error);
                    toastr.error('Ocurrió un error al eliminar el kit');
                    this.deleting = false;
                });
        },
        saveKit() {
            this.$bus.$emit('kit-form.save');
        },
        onSave() {
            this.closeForm();
            this.loadKits();
        },
        openForm() {
            this.$bus.$emit('kit-form.open');
        },
        closeForm() {
            this.$bus.$emit('kit-form.close');
            this.kit = null;
        }
    },
    created() {
        this.loadKits();
        this.loadAvailableItems();
    }
};
</script>

